import React from "react";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const SOCIAL_LINKS = [
  {
    name: "GitHub",
    url: "https://github.com/iamdheerajjain",
    icon: AiFillGithub,
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/iamdheerajjain/",
    icon: FaLinkedinIn,
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/dj_prakul_2004",
    icon: AiFillInstagram,
  },
];

function SocialLinks({ className = "", iconClassName = "" }) {
  return (
    <ul className={className}>
      {SOCIAL_LINKS.map(({ name, url, icon: Icon }) => (
        <li key={name} className="social-icons">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={iconClassName}
          >
            <Icon />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default React.memo(SocialLinks);
